(function userAddCertificateControllerDefinition() {
    'use strict';

    angular.module('User')
        .controller('UserAddCertificateController', [
            '$scope', 'config', '$state', '$stateParams', '$translate', 'errorsExtend', 'certificateUserService', 'authExtend', 'adminUserService', 'notificationService',
            function organizationalUnitAddCertificateController($scope, config, $state, $stateParams, $translate, errors, certificateUserService, authExtend, adminUserService, notificationService) {

                var fileUploadInfo = null;

                var resetFileUpload = function resetFileUploadFn() {
                    fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('pkcs') > -1) {

                        if (fileUploadInfo.promise !== null) {
                            fileUploadInfo.promise.abort();
                            fileUploadInfo.promise = null;
                        }
                        fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        fileUploadInfo.selectedFile = files[0];

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.removeCertificate = function () {
                    resetFileUpload();
                };

                $scope.cancel = function () {
                    $state.goBack('user-find');
                };

                $scope.save = function () {
                    if (!fileUploadInfo.selectedFile || !$scope.certificate.expirationDate) {
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if (fileUploadInfo.promise !== null) {
                        fileUploadInfo.promise.abort();
                        fileUploadInfo.promise = null;
                    }
                    return certificateUserService.upload($scope.certificate, fileUploadInfo.selectedFile).then(function () {
                        adminUserService.getById($stateParams.id, false).then(function (result) {
                            notificationService.deleteNotifications($stateParams.id).then(function () {

                                var notificationDate = new Date($scope.certificate.expirationDate);
                                notificationDate.setDate($scope.certificate.expirationDate.getDate() - 30);
                                var params = {
                                    organizationalUnitId: $stateParams.ouId,
                                    owner: $stateParams.id,
                                    ownerName: result.lastName + ' ' + result.firstName,
                                    mail: result.mail,
                                    notificationDate: notificationDate
                                };

                                notificationService.createEmployerCertificateExpirateNotifications(params).then(function (result) {
                                    $state.go('user-find');
                                }, function (error) {
                                    errors.showError(error);
                                    $state.go('user-find');
                                });
                            });
                            errors.showSuccess('UserCertificateUploadedSuccessfully');
                        }, function (error) {
                            errors.showError(error);
                        });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.load = function () {
                    $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);
                    resetFileUpload();
                    $scope.certificate = {
                        userId: $stateParams.id,
                        userName: $stateParams.userName,
                        organizationalUnitId: $stateParams.ouId,
                        type: 1, //este atributo es para identificar si es de apoderado o empleado (0=empleado, 1=apoderado)
                        expirationDate: new Date(),
                        revocationPin: '',
                        notInTree: true
                    }
                    certificateUserService.getById($scope.certificate).then(function (result) {
                        $scope.existingCertificate = result;
                    });
                };

                $scope.load();
            }
        ]);
})();
